import type { RoseRocketOrder } from '../types/entities';
import { isCurrency, isIsoDate, isIsoTimestamp, required } from './common';

export function validateOrder(order: RoseRocketOrder): string[] {
  const errors: string[] = [];
  if (!required(order.id)) errors.push('Missing order id');
  if (!required(order.order_number)) errors.push('Missing order number');
  if (!required(order.status)) errors.push('Missing order status');
  if (!required(order.customer_name)) errors.push('Missing customer name');
  if (!isIsoTimestamp(order.updated_at)) errors.push('Invalid updated_at timestamp');
  if (!isIsoDate(order.pickup_date)) errors.push('Invalid pickup date');
  if (!isIsoDate(order.delivery_date)) errors.push('Invalid delivery date');
  if (order.rate !== undefined && Number.isNaN(Number(order.rate))) errors.push('Invalid rate');
  if (!isCurrency(order.currency)) errors.push('Invalid currency code');
  return errors;
}
